import * as utils from '../js/utils';
import * as api from '../js/api';

function redirectTo() {
    const url = utils.clearURLQueryString({url: window.location.href} );
    url.searchParams.set('action', 'resetpass');
    return url.href;
}

function lostpassword() {
    const url = utils.clearURLQueryString({url: window.location.href} );
    url.searchParams.set('action', 'lostpassword');

    // 'error' is a reserved term and gets filtered.
    url.searchParams.set('err', 'invalidkey');

    return url.href;
}

function validate(form: HTMLFormElement) {
    let error = true;
    utils.clearFieldErrors({parent: form});

    const pass1 = form.querySelector('input[name="pass1"]') as HTMLInputElement;
    if (!pass1.value) {
        utils.setFieldError({input: pass1, message: 'The password is required.'});
        error = false;
    }
    const pass2 = form.querySelector('input[name="pass2"]') as HTMLInputElement;
    if (!pass2.value) {
        utils.setFieldError({input: pass2, message: 'Please confirm the password.'});
        error = false;
    } else if (pass1.value !== pass2.value) {
        utils.setFieldError({input: pass2, message: 'The password must match.'});
        error = false;
    }

    return error;
}

async function handleSubmit(event: Event) {
    event.preventDefault();

    const form = event.target as HTMLFormElement;
    if (!validate(form)) {
        return;
    }

    utils.setLoading({form: event.target, isLoading: true});

    const body = utils.formData({form});
    body.password = body.pass1;
    body.pass1 = body.pass2 = undefined;

    try {
        await api.post('/resetpass', body);
        window.location.href = redirectTo();
    } catch( e ) {
        const message = utils.getErrorMessage(e);
        if (message.toLowerCase().includes('invalid key')) {
            window.location.href = lostpassword();
        }
        utils.showMessage( {form, message} );
    }

    utils.setLoading({form: event.target, isLoading: false});
}

export default function () {
    document.querySelectorAll('.payments-password-reset-form').forEach((element) => {
        element.addEventListener('submit', handleSubmit);
    });
}